// removed by extract-text-webpack-plugin
module.exports = {"WrapperContainer":"styles__WrapperContainer___1e9y2","Container":"styles__Container___3sYp_","Header":"styles__Header___33yW0","Title":"styles__Title___3BVp2","Tariffs":"styles__Tariffs___1EkHZ","Footer":"styles__Footer___HRYml","SubGroup1":"styles__SubGroup1___SBIK9","SubGroup2":"styles__SubGroup2___3OPsD","SubGroup3":"styles__SubGroup3___-em2x","SubGroup":"styles__SubGroup___2PPTU"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Rates/styles.scss
// module id = 1481
// module chunks = 0